import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {css} from "@emotion/css"
import {RouteInfo} from "../../../route/RouteHelper";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import InputSubmitCodeRaiko from "../../../raikoComponents/raikoInputs/InputSubmitCodeRaiko";
import {LoginService} from "../../../connection-services/login/LoginService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../../context/LoadingContext";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {useAuthDispatcher, useAuthState} from "../../../context/AuthContext";
import {setUserRefreshToken, writeFundId, writeFundName} from "../../../service/localStorage/LocalStorageService";
import {actionTypes, setLoginStateDispatch} from "../../../context/reducer";
import CountDownTimer from "../../../component/countDownTimer/CountDownTimer";
import {Helmet} from "react-helmet";

import jwt from 'jwt-decode'
import {GeneralService} from "../../../serverService/generalService/GeneralService";
import {RaikoInputSubmitCode, showErrorMessage,RaikoButtonPrimary} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {CashService} from "../../../serverService/cashService/CashService";
import {writeNewToken} from "../../../service/authService/AuthService";


export default function SignInEnterSubmitCode() {

    const service = new LoginService()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const {state} = useLocation()

    const [username, setUsername] = useState(state.username);
    const [password, setPassword] = useState(state.password);

    const [timerAmount, setTimerAmount] = useState(120);

    const [submitCode, setSubmitCode] = useState("");

    const dispatch = useAuthDispatcher()
    const {loginState} = useAuthState()
    const navigate = useNavigate()

    useEffect(() => {
        if (typeof loginState !== "undefined" && loginState) {
            navigate(RouteInfo.Dashboard.globalUrl, {replace: true})
        }
    }, [loginState])

    function validateEnterInfo() {
        /*setUserRefreshToken("response.data.refresh_token")

        dispatch(
            setLoginStateDispatch(
                actionTypes.LOGIN,
                "response.data.access_token",
                []
            )
        )*/

        loading.show()
        service.loginUser(username, submitCode)
            .then(response => {

                // const refreshToken = response.data.refresh_token;
                // const token = response.data.access_token;
                writeNewToken(response.data.access_token)
                getAvailableCashList(response.data)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })

    }

    function getAvailableCashList(loginInfo) {
        if (jwt(loginInfo.access_token).total_owner === true) {
            new GeneralService()
                .getAvailableCashList(0, 1)
                .then(response => {
                    if (response.data.length > 0) {
                        setUserLoginState(
                            loginInfo,
                            response.data[0].id,
                            response.data[0].name,
                            true
                        )
                    }
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            })
        } else {
            new CashService()
                .getAvailableCashList()
                .then(response => {
                    if (response[0]) {
                        setUserLoginState(
                            loginInfo,
                            response[0].id,
                            response[0].name,
                            false
                        )
                    } else {
                        showErrorMessage("مدیریت هیچ صندوقی به شما تعلق نگرفته است!")
                    }
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            })
        }


    }

    function setUserLoginState(loginInfo, fundId, title, totalOwner) {
        setUserRefreshToken(loginInfo.refresh_token)

        writeFundId(fundId)
        writeFundName(title)

        dispatch(
            setLoginStateDispatch(
                actionTypes.LOGIN,
                loginInfo.access_token,
                "ADMIN",
                fundId,
                title,
                totalOwner
            ))
    }

    function handleSendSmsAgain() {
        loading.show()
        service.sendVerificationCode(username, password, "")
            .then(response => {
                setTimerAmount(120)
                snackbar.showSuccessMessage("کد تایید با موفقیت ارسال شد.")
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason, "خطا در ارسال کد تایید")
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInEnterSubmitCode.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>کد تایید</span>
                </div>
                <form className={"signInContentContainer"}>
                    <p className={"signInTitle"}>لطفا کد تایید ارسال شده را وارد نمایید.</p>
                    <div className={"editInfoContainer"}>
                        <Link className={"editPhoneNumber"} to={RouteInfo.SignInEnterPhoneNumber.url}>
                            <div className={"ic-edit"}></div>
                            <span>ویرایش اطلاعات ورود</span>
                        </Link>

                    </div>
                    <RaikoInputSubmitCode
                        labelText={""}
                        handleCheckCode={validateEnterInfo}
                        value={submitCode}
                        getCodeValue={setSubmitCode}
                    />

                    <RaikoButtonPrimary
                        label={"ورود به سامانه"}
                        className={css`width: 100%`}
                        onClick={validateEnterInfo}
                    />


                    <span className={"timerContainer"}>
                        <CountDownTimer
                            firstTimeInSeconds={timerAmount}
                            endTimeClickedEvent={handleSendSmsAgain}
                            endTimeMessage={"ارسال مجدد"}
                        />
                </span>

                </form>
            </div>
        </>
    )
}